// Decide o que o app deve OFERECER a quem esta olhando a tela: instalar de
// verdade, ou a instrucao certa para o navegador em que a pessoa esta.
//
// Pura de proposito -- o vitest deste projeto roda sem DOM, entao componente
// com hook nao e testavel. Aqui mora a decisao; o componente so desenha.
// Ver estadoDaInstalacao.test.ts para o caso real que originou o arquivo.

export type Estado =
  /** Ja esta rodando como aplicativo: nao ha nada a oferecer. */
  | 'ja-instalado'
  /** O navegador entregou o evento: da para instalar com um toque. */
  | 'pode-instalar'
  /** Navegador de dentro de outro app (WhatsApp, Instagram): nao instala nunca. */
  | 'navegador-interno'
  /** Safari do iPhone: instalacao so manual, por Compartilhar. */
  | 'iphone'
  /** Chrome do Android sem o evento: instalacao pelo menu do navegador. */
  | 'android-manual'
  /** Computador e o resto: nao ha instrucao util a dar. */
  | 'nada-a-fazer'

export type Sistema = 'android' | 'ios' | 'outro'

export type Situacao = { estado: Estado; sistema: Sistema }

export type EntradaDaInstalacao = {
  /** O navegador ja mandou `beforeinstallprompt` e ele esta guardado. */
  temEventoDeInstalar: boolean
  /** `display-mode: standalone` -- a pagina esta aberta como aplicativo. */
  estaEmModoApp: boolean
  userAgent: string
}

/** Apps conhecidos que abrem link num navegador proprio, sem instalacao. */
const APPS_COM_NAVEGADOR_PROPRIO = /FBAN|FBAV|Instagram|Line\/|MicroMessenger|Twitter/

export function estadoDaInstalacao({
  temEventoDeInstalar,
  estaEmModoApp,
  userAgent,
}: EntradaDaInstalacao): Situacao {
  const ehIOS = /iPhone|iPad|iPod/.test(userAgent)
  const ehAndroid = /Android/.test(userAgent)
  const sistema: Sistema = ehIOS ? 'ios' : ehAndroid ? 'android' : 'outro'

  // Instalado vence tudo: sem esta ordem, o app instalado seguiria oferecendo
  // instalar-se de novo.
  if (estaEmModoApp) return { estado: 'ja-instalado', sistema }

  if (temEventoDeInstalar) return { estado: 'pode-instalar', sistema }

  // O WebView do Android se identifica pelo token "; wv". No iOS nao ha token
  // proprio, mas o Safari de verdade SEMPRE traz "Version/x.y" -- a ausencia
  // dele denuncia navegador embutido. Isso tambem pega o Chrome do iPhone
  // (CriOS), que igualmente nao instala nada: la so o Safari adiciona a tela.
  const webViewDoAndroid = ehAndroid && /;\s*wv/.test(userAgent)
  const webViewDoIOS = ehIOS && !/Version\//.test(userAgent)
  if (webViewDoAndroid || webViewDoIOS || APPS_COM_NAVEGADOR_PROPRIO.test(userAgent)) {
    return { estado: 'navegador-interno', sistema }
  }

  if (ehIOS) return { estado: 'iphone', sistema }
  if (ehAndroid) return { estado: 'android-manual', sistema }
  return { estado: 'nada-a-fazer', sistema }
}
